// extracted by mini-css-extract-plugin
export default {"container":"video_container__30OJW","isContainer":"video_isContainer__2OY2z"};